import BaseServiceCrud from './BaseServiceCrud';

export default class DriverService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'driver';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            last_name: criteria.lastName,
            pesel: criteria.pesel,
            document_number: criteria.documentNumber,
            own: criteria.own,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${element.sapId}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    
    delete(element) {
        return this.fetch(`${this.domain}/${this.path}/${element.sapId}`, {
            method: 'DELETE',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
